// extracted by mini-css-extract-plugin
export default {"copyText":"src-hellospa-components-global-header-copy-text__copyText--1cYzJ","textCopiedMessage":"src-hellospa-components-global-header-copy-text__textCopiedMessage--3Xo6z"};